export function useOnChangeFilterHandler<T>(name: string, cb: (v: { [name: string]: T }) => void) {
  return (value: T) => {
    cb({ [name]: value });
  };
}
